import { Badge } from '@/components/ui/badge';
import type { TicketListItem } from '@/services/tech-support.service';

type BadgeVariant = React.ComponentProps<typeof Badge>['variant'];

const STATUS_CONFIG: Record<TicketListItem['status'], { label: string; variant: BadgeVariant }> = {
  open:        { label: 'Open',        variant: 'default' },
  in_progress: { label: 'In Progress', variant: 'warning' },
  waiting:     { label: 'Waiting',     variant: 'secondary' },
  resolved:    { label: 'Resolved',    variant: 'success' },
  closed:      { label: 'Closed',      variant: 'outline' },
};

interface Props {
  status: TicketListItem['status'];
}

export function TicketStatusBadge({ status }: Props) {
  const cfg = STATUS_CONFIG[status] ?? { label: status, variant: 'secondary' as BadgeVariant };
  return <Badge variant={cfg.variant}>{cfg.label}</Badge>;
}
